import { Component } from "react";
import ImageComponent from "./ImageComponent";

interface IPlaceHolderImageProps {
  type: string;
  imageSource: string;
}

export default class PlaceHolderImage extends Component<IPlaceHolderImageProps> {
  render() {
    const { type, imageSource } = this.props;

    return <ImageComponent src={imageSource} alt={type + " Placeholder"} />;
  }
}
